import type { AskFormArgs } from './tools';

type PropSchema = { oneOf?: { const: unknown; title: string }[]; title?: string };

/**
 * Builds a human-readable label from a widget result.
 * Used by both the backend (widgetResultToText) and the frontend (resumeWidget)
 * so the persisted transcript and the optimistic UI label are always identical.
 */
export function formatWidgetResult(name: string, args: unknown, result: unknown): string {
  if (name === 'ask_form') {
    const formData = (result as { formData?: Record<string, unknown> })?.formData ?? {};
    const props = ((args as AskFormArgs | undefined)?.schema?.properties ?? {}) as Record<string, PropSchema>;
    const parts = Object.entries(formData)
      .map(([k, v]) => props[k]?.oneOf?.find((o) => o.const === v)?.title ?? String(v))
      .filter(Boolean);
    return parts.join(' · ') || JSON.stringify(formData);
  }
  /* Generic fallback for other widget types (ask_mcq, render_interactive, …) */
  if (typeof result === 'string') return result.trim();
  if (typeof result === 'number' || typeof result === 'boolean') return String(result);
  if (result && typeof result === 'object') {
    const o = result as Record<string, unknown>;
    for (const k of ['label', 'choix', 'text', 'answer', 'choice', 'title', 'value']) {
      const v = o[k];
      if (typeof v === 'string' && v.trim()) return v.trim();
      if (typeof v === 'number') return String(v);
    }
    try { return JSON.stringify(result).slice(0, 200); } catch { /* fall through */ }
  }
  return '';
}
